import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Divider, Checkbox} from 'antd';

import {RTLCol,RTLButton} from '../RTLKit';


/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';
import UploadField from '../formFields/UploadField';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";
import CheckBoxField from "../formFields/CheckBoxField";

class AddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities:[],
            formLayout: 'horizontal',
            role:this.props.userValue ? this.props.userValue.rl : null,
            replacement:false,
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        this.props.getCategoryList();
        if (this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.getItem(id)
        }


    }
    __goBack(){
        this.props.history.goBack()
    }

    __getCategoryList() {
        let categoryList = this.props.categoryList;
        let dataSource = [];
        let categoryType;

        if (categoryList) {

            for (let i = 0; i < categoryList.lists.length; i++) {
                if(categoryList.lists[i].product_type === "PRODUCT_CATEGORY_CUSTOMER_TYPE")
                    categoryType = 'مشتری'
                else
                    categoryType = 'تکنسین'

                dataSource.push(
                    {label: categoryList.lists[i].title+' ('+categoryType+')', value: categoryList.lists[i]._id, key: i}
                );

            }

        }
        return dataSource;
    }

    __changeReplacement(val){
        val = val.target.value
        this.setState({
            replacement : val.value,
        })
        if(this.state.mode === 'edit')
            this.props.initialValues.is_need_replacement=val.value
    }

    __changeGuarantee(val){
        if(this.state.guarantee === true) {
            val = false
            if(this.state.mode === 'edit')
                this.props.initialValues.guarantee=0
        }else {
            val = true
            if(this.state.mode === 'edit')
                this.props.initialValues.guarantee=1
        }
        this.setState({
            guarantee : val
        })
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;
        /*---- set mode ---*/
        if(this.props.initialValues) {
            this.props.initialValues.mode=this.state.mode
        }

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">{this.state.mode == 'edit' ? "ویرایش" : "ایجاد"} محصول</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                    : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                            <Field
                                name="title"
                                component={TextField}
                                type="text"
                                label="عنوان"
                                placeholder="عنوان"
                            />
                            <Field
                                name="description"
                                component={TextField}
                                type="text"
                                label="توضیحات"
                                placeholder="توضیحات"
                            />
                            <Field
                                name="productCayegoryId"
                                component={SelectField}
                                label="دسته بندی"
                                placeholder="دسته بندی"
                                list={this.__getCategoryList()}
                                defaultValue={(this.props.initialValues && this.props.initialValues.product_category._id ? this.props.initialValues.product_category._id : null)}

                            />
                            <RTLCol span={24}>
                                <RTLCol className="formLabel" md={5} sm={24}>
                                    <label>نیاز به تعویض دوره ای دارد:</label>
                                </RTLCol>
                                <RTLCol md={19} sm={24} style={{marginBottom : 20}}>
                                    <Row>
                                        <RTLCol span={8}>
                                            <Checkbox
                                                name="is_need_replacement"
                                                value={{label : '' , value : !this.state.replacement}}
                                                style={{ width: '100%',paddingTop:10,textAlign:'right' }}
                                                onChange={(val) => this.__changeReplacement(val)}
                                                defaultValue={this.state.mode === 'edit' && this.props.initialValues && this.props.initialValues.is_need_replacement ? true : false}
                                                checked={
                                                    this.state.mode === 'edit' && this.props.initialValues && this.props.initialValues.is_need_replacement ?
                                                        true : this.state.replacement}
                                            >
                                            </Checkbox>
                                        </RTLCol>
                                    </Row>
                                </RTLCol>
                            </RTLCol>


                            {/*<Field*/}
                            {/*    name="is_need_replacement"*/}
                            {/*    component={CheckBoxField}*/}
                            {/*    label="نیاز به تعویض دوره ای دارد"*/}
                            {/*    list={[{label : '' , value : 1}]}*/}
                            {/*    onChange={(val) => this.setState({replacement : val})}*/}
                            {/*    defaultValue={this.state.mode === 'edit' && this.props.initialValues && this.props.initialValues.is_need_replacement ? true : false}*/}
                            {/*/>*/}
                            {(this.state.replacement == 1 || (this.props.initialValues && this.state.mode == 'edit' && this.props.initialValues.is_need_replacement)) ?
                                <Field
                                    name="minimum_usage"
                                    component={TextField}
                                    type="number"
                                    label="حداقل استفاده به روز"
                                    placeholder="حداقل استفاده به روز"
                                />
                                :null}
                            <RTLCol span={24}>
                                <RTLCol className="formLabel" md={5} sm={24}>
                                    <label>گارانتی دارد:</label>
                                </RTLCol>
                                <RTLCol md={19} sm={24} style={{marginBottom : 20}}>
                                    <Row>
                                        <RTLCol span={8}>
                                            <Checkbox
                                                name="has_gaurantee"
                                                value={[{label : '' , value : 1}]}
                                                style={{ width: '100%',paddingTop:10,textAlign:'right' }}
                                                onChange={(val) => this.__changeGuarantee(val)}
                                                defaultValue={this.state.mode === 'edit' && this.props.initialValues && this.props.initialValues.guarantee > 0 ? true : false}
                                                checked={this.state.mode === 'edit' && this.props.initialValues && this.props.initialValues.guarantee > 0 ? true : this.state.guarantee}
                                            >
                                            </Checkbox>
                                        </RTLCol>
                                    </Row>
                                </RTLCol>
                            </RTLCol>

                            {/*<Field*/}
                            {/*    name="has_gaurantee"*/}
                            {/*    component={CheckBoxField}*/}
                            {/*    label="گارانتی دارد"*/}
                            {/*    list={[{label : '' , value : 1}]}*/}
                            {/*    onChange={(val) => this.setState({guarantee : val})}*/}
                            {/*    defaultValue={this.state.mode === 'edit' && this.props.initialValues && this.props.initialValues.guarantee > 0 ? true : false}*/}
                            {/*/>*/}
                            {(this.state.guarantee == 1 || (this.props.initialValues && this.state.mode == 'edit' && this.props.initialValues.guarantee)) ?
                                <Field
                                    name="guarantee"
                                    component={TextField}
                                    type="number"
                                    label="مدت گارانتی به روز"
                                    placeholder="مدت گارانتی به روز"
                                />
                            :null}
                            <Field
                                name="price"
                                component={TextField}
                                type="number"
                                label="قیمت(ریال)"
                                placeholder="قیمت"
                            />
                            <Field
                                name="commission"
                                component={TextField}
                                type="number"
                                label="پورسانت تکنسین(ریال)"
                                placeholder="پورسانت تکنسین"
                            />
                            <Field
                                name="image"
                                component={UploadField}
                                token={this.props.userValue}
                                type="file"
                                label="تصویر محصول"
                                placeholder="تصویر محصول"
                                defaultValue={this.props.initialValues ? this.props.initialValues.image : null}
                                help="سایز عکس میبایست حتما 150*150 پیکسل و با فرمت png باشد"
                            />

                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode === 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/product/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default AddEditForm = reduxForm({
    form: 'addProduct',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(AddEditForm)
